import AbstractSeriesSpecification from "./AbstractSeriesSpecification.js";
import IsCostAccountRowVisitor from "./IsCostAccountRowVisitor.js";

/**
 * Concrete implementation of an {@link AbstractSeriesSpecification}
 * representing a computation request for an {@link AbstractRow}.
 */
export default class RowSeriesSpecification extends AbstractSeriesSpecification {
	setDataIntoRow({ row, columns }) {
		// Costs must be seen as positive values, whatever the negated setting value
		const shouldFlipSign =
			new IsCostAccountRowVisitor().visit(row) && row.isNegated();

		const data = this._values.map((value) => ({
			value: shouldFlipSign ? -value : value,
		}));

		row.setData({ data, columns });
	}

	static makeForReport({ report }) {
		return report
			.getAllRows()
			.filter((row) => row.canBeCalculated())
			.map((row) =>
				RowSeriesSpecification.makeFromModel({
					row,
					operationType: report.getOperationType({ row }),
				}),
			);
	}

	static makeNodeFromModel({ row }) {
		return row.asFormulaNode();
	}

	static getType() {
		return "RowSeriesSpecification";
	}

	static _makeKeyDataFromModel(data) {
		return {
			...super._makeKeyDataFromModel(data),
			id: data.row.getStableId(),
		};
	}
}
